import type { Language } from '../config';

export interface ProvinceData {
  th: string;
  en: string;
  zh: string;
  ru: string;
  ja: string;
  ko: string;
}

export interface ProvinceOption {
  value: string;
  label: string;
}

/**
 * 77 Provinces of Thailand sorted alphabetically by Thai script (ก-ฮ)
 * Includes full multi-language translations (th, en, zh, ru, ja, ko)
 */
export const THAILAND_PROVINCES: ProvinceData[] = [
  { th: 'กระบี่', en: 'Krabi', zh: '甲米', ru: 'Краби', ja: 'クラビ', ko: '끄라비' },
  { th: 'กรุงเทพมหานคร', en: 'Bangkok', zh: '曼谷', ru: 'Бангкок', ja: 'バンコク', ko: '방콕' },
  { th: 'กาญจนบุรี', en: 'Kanchanaburi', zh: '北碧', ru: 'Канчанабури', ja: 'カーンチャナブリー', ko: '깐차나부리' },
  { th: 'กาฬสินธุ์', en: 'Kalasin', zh: '加拉信', ru: 'Каласин', ja: 'カーラシン', ko: '까라신' },
  { th: 'กำแพงเพชร', en: 'Kamphaeng Phet', zh: '甘烹碧', ru: 'Кампхэнгпхет', ja: 'カムペーンペット', ko: '깜팽펫' },
  { th: 'ขอนแก่น', en: 'Khon Kaen', zh: '孔敬', ru: 'Кхонкэн', ja: 'コーンケン', ko: '콘깬' },
  { th: 'จันทบุรี', en: 'Chanthaburi', zh: '尖竹汶', ru: 'Чантхабури', ja: 'チャンタブリー', ko: '짠타부리' },
  { th: 'ฉะเชิงเทรา', en: 'Chachoengsao', zh: '北柳', ru: 'Чачонгсао', ja: 'チャチューンサオ', ko: '차층사오' },
  { th: 'ชลบุรี', en: 'Chon Buri (Pattaya)', zh: '春武里 (芭提雅)', ru: 'Чонбури (Паттайя)', ja: 'チョンブリー (パタヤ)', ko: '촌부리 (파타야)' },
  { th: 'ชัยนาท', en: 'Chai Nat', zh: '猜纳', ru: 'Чайнат', ja: 'チャイナート', ko: '차이낫' },
  { th: 'ชัยภูมิ', en: 'Chaiyaphum', zh: '猜也奔', ru: 'Чайяпхум', ja: 'チャイヤプーム', ko: '차이야품' },
  { th: 'ชุมพร', en: 'Chumphon', zh: '春蓬', ru: 'Чумпхон', ja: 'チュムポーン', ko: '춤폰' },
  { th: 'เชียงราย', en: 'Chiang Rai', zh: '清莱', ru: 'Чианграй', ja: 'チェンライ', ko: '치앙라이' },
  { th: 'เชียงใหม่', en: 'Chiang Mai', zh: '清迈', ru: 'Чиангмай', ja: 'チェンマイ', ko: '치앙마이' },
  { th: 'ตรัง', en: 'Trang', zh: '董里', ru: 'Транг', ja: 'トラン', ko: '뜨랑' },
  { th: 'ตราด', en: 'Trat (Koh Chang)', zh: '达叻 (象岛)', ru: 'Трат (Ко Чанг)', ja: 'トラート (チャーン島)', ko: '뜨랏 (꼬창)' },
  { th: 'ตาก', en: 'Tak', zh: '达府', ru: 'Так', ja: 'ターク', ko: '딱' },
  { th: 'นครนายก', en: 'Nakhon Nayok', zh: '那空那育', ru: 'Накхоннайок', ja: 'ナコーンナーヨック', ko: '나콘나욕' },
  { th: 'นครปฐม', en: 'Nakhon Pathom', zh: '佛统', ru: 'Накхонпатхом', ja: 'ナコーンパトム', ko: '나콘빠톰' },
  { th: 'นครพนม', en: 'Nakhon Phanom', zh: '那空帕侬', ru: 'Накхонпханом', ja: 'ナコーンパノム', ko: '나콘파놈' },
  { th: 'นครราชสีมา', en: 'Nakhon Ratchasima (Khorat)', zh: '呵叻', ru: 'Накхонратчасима (Корат)', ja: 'ナコーンラーチャシーマー', ko: '나콘랏차시마' },
  { th: 'นครศรีธรรมราช', en: 'Nakhon Si Thammarat', zh: '洛坤', ru: 'Накхонситхаммарат', ja: 'ナコーンシータマラート', ko: '나콘시탐마랏' },
  { th: 'นครสวรรค์', en: 'Nakhon Sawan', zh: '北榄坡', ru: 'Накхонсаван', ja: 'ナコーンサワン', ko: '나콘사완' },
  { th: 'นนทบุรี', en: 'Nonthaburi', zh: '暖武里', ru: 'Нонтхабури', ja: 'ノンタブリー', ko: '논타부리' },
  { th: 'นราธิวาส', en: 'Narathiwat', zh: '陶公', ru: 'Наратхиват', ja: 'ナラーティワート', ko: '나라티왓' },
  { th: 'น่าน', en: 'Nan', zh: '难府', ru: 'Нан', ja: 'ナーン', ko: '난' },
  { th: 'บึงกาฬ', en: 'Bueng Kan', zh: '汶干', ru: 'Бынгкан', ja: 'ブンカーン', ko: '븡깐' },
  { th: 'บุรีรัมย์', en: 'Buri Ram', zh: '武里南', ru: 'Бурирам', ja: 'ブリーラム', ko: '부리람' },
  { th: 'ปทุมธานี', en: 'Pathum Thani', zh: '巴吞他尼', ru: 'Патхумтхани', ja: 'パトゥムターニー', ko: '빠툼타니' },
  { th: 'ประจวบคีรีขันธ์', en: 'Prachuap Khiri Khan (Hua Hin)', zh: '巴蜀 (华欣)', ru: 'Прачуапкхирикхан (Хуахин)', ja: 'プラチュワップキーリーカン (ホアヒン)', ko: '프라추압키리칸 (후아힌)' },
  { th: 'ปราจีนบุรี', en: 'Prachin Buri', zh: '巴真', ru: 'Прачинбури', ja: 'プラーチーンブリー', ko: '쁘라친부리' },
  { th: 'ปัตตานี', en: 'Pattani', zh: '北大年', ru: 'Паттани', ja: 'パッターニー', ko: '파타니' },
  { th: 'พระนครศรีอยุธยา', en: 'Phra Nakhon Si Ayutthaya', zh: '大城', ru: 'Аюттхая', ja: 'アユタヤ', ko: '아유타야' },
  { th: 'พะเยา', en: 'Phayao', zh: '帕尧', ru: 'Пхаяу', ja: 'パヤオ', ko: '파야오' },
  { th: 'พังงา', en: 'Phangnga (Khao Lak)', zh: '攀牙 (拷叻)', ru: 'Пхангнга (Као Лак)', ja: 'パンガー (カオラック)', ko: '팡아 (카오락)' },
  { th: 'พัทลุง', en: 'Phatthalung', zh: '博他仑', ru: 'Пхаттхалунг', ja: 'パッタルン', ko: '파탈룽' },
  { th: 'พิจิตร', en: 'Phichit', zh: '披集', ru: 'Пхичит', ja: 'ピチット', ko: '피칫' },
  { th: 'พิษณุโลก', en: 'Phitsanulok', zh: '彭世洛', ru: 'Пхитсанулок', ja: 'ピッサヌローク', ko: '핏사눌록' },
  { th: 'เพชรบุรี', en: 'Phetchaburi (Cha-am)', zh: '佛丕 (七岩)', ru: 'Пхетчабури (Ча-ам)', ja: 'ペッチャブリー (チャアム)', ko: '펫차부리 (차암)' },
  { th: 'เพชรบูรณ์', en: 'Phetchabun (Khao Kho)', zh: '碧差汶 (考科)', ru: 'Пхетчабун (Као Кхо)', ja: 'ペッチャブーン (カオコー)', ko: '펫차분 (카오코)' },
  { th: 'แพร่', en: 'Phrae', zh: '帕府', ru: 'Пхрэ', ja: 'プレー', ko: '프래' },
  { th: 'ภูเก็ต', en: 'Phuket', zh: '普吉岛', ru: 'Пхукет', ja: 'プーケット', ko: '푸껫' },
  { th: 'มหาสารคาม', en: 'Maha Sarakham', zh: '玛哈沙拉堪', ru: 'Махасаракхам', ja: 'マハーサーラカーム', ko: '마하사라캄' },
  { th: 'มุกดาหาร', en: 'Mukdahan', zh: '穆达汉', ru: 'Мукдахан', ja: 'ムックダーハーン', ko: '묵다한' },
  { th: 'แม่ฮ่องสอน', en: 'Mae Hong Son (Pai)', zh: '夜丰颂 (拜县)', ru: 'Мэхонгсон (Пай)', ja: 'メーホンソーン (パーイ)', ko: '매홍손 (빠이)' },
  { th: 'ยโสธร', en: 'Yasothon', zh: '益梭通', ru: 'Ясотхон', ja: 'ヤソートーン', ko: '야소톤' },
  { th: 'ยะลา', en: 'Yala (Betong)', zh: '也拉 (勿洞)', ru: 'Яла (Бетонг)', ja: 'ヤラー (ベートン)', ko: '얄라 (베통)' },
  { th: 'ร้อยเอ็ด', en: 'Roi Et', zh: '黎逸', ru: 'Ройет', ja: 'ローイエット', ko: '로이엣' },
  { th: 'ระนอง', en: 'Ranong', zh: '拉侬', ru: 'Ранонг', ja: 'ラノーン', ko: '라농' },
  { th: 'ระยอง', en: 'Rayong (Koh Samet)', zh: '罗勇 (沙美岛)', ru: 'Районг (Ко Самет)', ja: 'ラヨーン (サメット島)', ko: '라용 (사멧섬)' },
  { th: 'ราชบุรี', en: 'Ratchaburi (Suan Phueng)', zh: '叻丕 (愿蓬)', ru: 'Ратчабури (Суанпхынг)', ja: 'ラーチャブリー', ko: '랏차부리' },
  { th: 'ลพบุรี', en: 'Lop Buri', zh: '华富里', ru: 'Лопбури', ja: 'ロッブリー', ko: '롭부리' },
  { th: 'ลำปาง', en: 'Lampang', zh: '南邦', ru: 'Лампанг', ja: 'ランパーン', ko: '람빵' },
  { th: 'ลำพูน', en: 'Lamphun', zh: '南奔', ru: 'Лампхун', ja: 'ランプーン', ko: '람푼' },
  { th: 'เลย', en: 'Loei (Chiang Khan)', zh: '黎府 (清刊)', ru: 'Лей (Чиангкхан)', ja: 'ルーイ (チェンカーン)', ko: '로에이 (치앙칸)' },
  { th: 'ศรีสะเกษ', en: 'Si Sa Ket', zh: '四色菊', ru: 'Сисакет', ja: 'シーサケート', ko: '시사껫' },
  { th: 'สกลนคร', en: 'Sakon Nakhon', zh: '色军', ru: 'Саконнакхон', ja: 'サコーンナコーン', ko: '사꼰나콘' },
  { th: 'สงขลา', en: 'Songkhla (Hat Yai)', zh: '宋卡 (合艾)', ru: 'Сонгкхла (Хатъяй)', ja: 'ソンクラー (ハートヤイ)', ko: '송클라 (핫야이)' },
  { th: 'สตูล', en: 'Satun (Koh Lipe)', zh: '沙敦 (丽贝岛)', ru: 'Сатун (Ко Липе)', ja: 'サトゥーン (リペ島)', ko: '사뚠 (꼬리뻬)' },
  { th: 'สมุทรปราการ', en: 'Samut Prakan', zh: '北榄', ru: 'Самутпракан', ja: 'サムットプラーカーン', ko: '사뭇쁘라깐' },
  { th: 'สมุทรสงคราม', en: 'Samut Songkhram (Amphawa)', zh: '夜功 (安帕瓦)', ru: 'Самутсонгкхрам (Ампхава)', ja: 'サムットソンクラーム', ko: '사뭇송크람' },
  { th: 'สมุทรสาคร', en: 'Samut Sakhon', zh: '龙仔厝', ru: 'Самутсакхон', ja: 'サムットサーコーン', ko: '사뭇사콘' },
  { th: 'สระแก้ว', en: 'Sa Kaeo', zh: '沙缴', ru: 'Сакэу', ja: 'サケーオ', ko: '사깨오' },
  { th: 'สระบุรี', en: 'Saraburi', zh: '北标', ru: 'Сарабури', ja: 'サラブリー', ko: '사라부리' },
  { th: 'สิงห์บุรี', en: 'Sing Buri', zh: '信武里', ru: 'Сингбури', ja: 'シンブリー', ko: '싱부리' },
  { th: 'สุโขทัย', en: 'Sukhothai', zh: '素可泰', ru: 'Сукхотхай', ja: 'スコータイ', ko: '수코타이' },
  { th: 'สุพรรณบุรี', en: 'Suphan Buri', zh: '素攀', ru: 'Супханбури', ja: 'スパンブリー', ko: '수판부리' },
  { th: 'สุราษฎร์ธานี', en: 'Surat Thani (Koh Samui / Phangan)', zh: '素叻他尼 (苏梅岛 / 帕岸岛)', ru: 'Сураттхани (Самуи / Панган)', ja: 'スラーターニー (サムイ島)', ko: '수랏타니 (코사무이 / 코팡안)' },
  { th: 'สุรินทร์', en: 'Surin', zh: '素林', ru: 'Сурин', ja: 'スリン', ko: '수린' },
  { th: 'หนองคาย', en: 'Nong Khai', zh: '廊开', ru: 'Нонгкхай', ja: 'ノーンカーイ', ko: '농카이' },
  { th: 'หนองบัวลำภู', en: 'Nong Bua Lam Phu', zh: '农磨兰普', ru: 'Нонгбуалампху', ja: 'ノーンブアランプー', ko: '농부아람푸' },
  { th: 'อ่างทอง', en: 'Ang Thong', zh: '红统', ru: 'Ангтхонг', ja: 'アントーン', ko: '앙통' },
  { th: 'อำนาจเจริญ', en: 'Amnat Charoen', zh: '安纳乍伦', ru: 'Амнатчарен', ja: 'アムナートチャルーン', ko: '암낫차른' },
  { th: 'อุดรธานี', en: 'Udon Thani', zh: '乌隆', ru: 'Удонтхани', ja: 'ウドーンターニー', ko: '우돈타니' },
  { th: 'อุตรดิตถ์', en: 'Uttaradit', zh: '程逸', ru: 'Уттарадит', ja: 'ウッタラディット', ko: '우따라딧' },
  { th: 'อุทัยธานี', en: 'Uthai Thani', zh: '乌泰他尼', ru: 'Утхайтхани', ja: 'ウタイターニー', ko: '우타이타니' },
  { th: 'อุบลราชธานี', en: 'Ubon Ratchathani', zh: '乌汶', ru: 'Убонратчатхани', ja: 'ウボンラーチャターニー', ko: '우본랏차타니' },
];

/**
 * Returns localized province options for select dropdown
 * Canonical value is always Thai name for consistent database storage and backend processing
 */
export function getLocalizedProvinces(lang: Language): ProvinceOption[] {
  return THAILAND_PROVINCES.map((p) => {
    let label = p.th;
    if (lang === 'en') {
      label = `${p.en} (${p.th})`;
    } else if (lang === 'zh') {
      label = `${p.zh} (${p.en})`;
    } else if (lang === 'ru') {
      label = `${p.ru} (${p.en})`;
    } else if (lang === 'ja') {
      label = `${p.ja} (${p.en})`;
    } else if (lang === 'ko') {
      label = `${p.ko} (${p.en})`;
    }
    return {
      value: p.th,
      label,
    };
  });
}
